import React, { ReactNode } from 'react';
import { Roles } from '../../types/Types';

// type Role = string;
interface Props {
  children: ReactNode;
  roles: Roles[];
}

export const RoleComponentRender: React.FC<Props> = ({ children, roles }) => {
  const userRole = localStorage.getItem('role') as Roles | null;
  if (!userRole) {
    return null;
  }

  if (roles.includes(userRole)) {
    return <>{children}</>;
  }

  return null;
};
